module.exports = __webpack_public_path__ + "media/application/images/ui/icon-comments-879fda07ea8a947241024e61e596600d.png";